var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"fill-height no-gutters"},[_c('v-col',{attrs:{"cols":"12"}},[_c('CurrencyTable'),_c('CurrencyForm')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }